import * as Yup from 'yup';

const idTypeValidationSchema = Yup.object().shape({
    idType: Yup.string().required('ID Type is required'),
    legalDepartment: Yup.string().oneOf(['yes', 'no'], 'Please select an option for the legal department').required('Legal department selection is required'),
    designation: Yup.string().required('Designation is required'),
});

export default idTypeValidationSchema;
